import { forwardRef } from "react";
import {
  NavLink as NavLinkBase,
  NavLinkProps,
  useLocation,
  useResolvedPath,
} from "react-router-dom";
import { mergeLocation, mergeSearch } from "utils/NavigationUtils";

interface Props extends NavLinkProps {}

export const NavLink = forwardRef<HTMLAnchorElement, Props>((props, ref) => {
  const location = useLocation();
  const { to, ...rest } = props;
  const path = useResolvedPath(to);
  const mergedSearch = mergeSearch(path, location);
  const mergedLocation = mergeLocation(to, path, location, mergedSearch);

  return <NavLinkBase to={{ ...mergedLocation }} ref={ref} {...rest} />;
});
